function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "7AE004E1-3AA8-4557-9C55-F307EABC4B02");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsMobileMenuExpanded",
  transform: "translate(-34.000000, -183.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "mobileNavigation",
  transform: "translate(0.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "row1",
  transform: "translate(0.000000, 77.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "section",
  transform: "translate(0.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sectionRow1",
  transform: "translate(34.000000, 42.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,4.41666667 L6.73313424,4.42076967 C10.2150053,4.54351605 13,7.40485472 13,10.9166667 L13,10.9166667 L12.995897,11.1498009 C12.8731506,14.631672 10.0118122,17.4166667 6.5,17.4166667 C2.9101475,17.4166667 -2.66453526e-15,14.5065192 -2.66453526e-15,10.9166667 C-2.66453526e-15,7.32681417 2.9101475,4.41666667 6.5,4.41666667 L6.5,4.41666667 Z M6.50000006,5.71666667 C3.62811806,5.71666667 1.30000006,8.04478467 1.30000006,10.9166667 C1.30000006,13.7885487 3.62811806,16.1166667 6.50000006,16.1166667 L6.50000006,16.1166667 L6.71981146,16.1121048 C9.48974207,15.9969185 11.7000001,13.7149107 11.7000001,10.9166667 L11.7000001,10.9166667 L11.6954382,10.6968553 C11.5802519,7.92692465 9.29824406,5.71666667 6.50000006,5.71666667 Z M8.45000023,10.2666667 C8.80898548,10.2666667 9.10000023,10.5576814 9.10000023,10.9166667 C9.10000023,11.2756519 8.80898548,11.5666667 8.45000023,11.5666667 L8.45000023,11.5666667 L4.55000026,11.5666667 C4.19101501,11.5666667 3.90000026,11.2756519 3.90000026,10.9166667 C3.90000026,10.5576814 4.19101501,10.2666667 4.55000026,10.2666667 L4.55000026,10.2666667 Z",
  id: "iconStatusMinusCircle"
})))))));

var SvgMinusCircle = function SvgMinusCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinusCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minus-circle.3e18ce81.svg";
export { ForwardRef as ReactComponent };